import { ProjectProvider } from './context/ProjectContext';
import { SidebarProvider } from './context/SidebarContext';
import { Layout } from '@/components/Layout/Layout';
import { AppRoutes } from './routes/AppRoutes';
import { ErrorBoundary } from '@/components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <ProjectProvider>
        <SidebarProvider>
          <Layout>
            <AppRoutes />
          </Layout>
        </SidebarProvider>
      </ProjectProvider>
    </ErrorBoundary>
  );
}